import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 日历面板的月份/星期名取自 dayjs locale（antd locale 只管按钮等文案），须显式切到 zh-cn
dayjs.locale('zh-cn');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// 注：不使用 <React.StrictMode>。wangEditor 在 StrictMode 的「挂载→卸载→再挂载」双调用下，
// 第一遍实例销毁后残留的 rAF 延迟回调会触发 toolbar 取不到 editor 而抛 "Can not get editor instance"。
// 该问题仅存在于 dev（生产构建无双调用），且为 wangEditor 官方已知不兼容点，故此处不启用 StrictMode。
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
